import { render, staticRenderFns } from "./thematicCollectionDetail.vue?vue&type=template&id=66e9f0fa&scoped=true"
import script from "./thematicCollectionDetail.vue?vue&type=script&lang=js"
export * from "./thematicCollectionDetail.vue?vue&type=script&lang=js"
import style0 from "./thematicCollectionDetail.vue?vue&type=style&index=0&id=66e9f0fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e9f0fa",
  null
  
)

export default component.exports